import * as Yup from "yup";

import { getValidationSchemaAddress } from "../../shared/validators/address/validationSchemaAddress";
import { WORKSITE_COUNTRY } from "./types";

export const validationSchemaWorksite = Yup.object().shape({
  name: Yup.string().required("Required"),
  address: getValidationSchemaAddress(WORKSITE_COUNTRY),
  externalId: Yup.string(),
  isPrimary: Yup.boolean()
});
